import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-513eec90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { temp: "c" }
const _hoisted_2 = { class: "detail-item" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_10 = { class: "detail-item" }

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice } from './data'
import { isD2C, isMultiStore } from '@/store'
import { showCurrentUnit } from '@/util/useYan'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "500px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowName), 1)
        ]),
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('日本配送公司')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.settlementDeliveryRespDTO?.distribution ?? ''), 1)
        ]),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('国际发货单号')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.settlementDeliveryRespDTO?.deliveryTaskCode ?? ''), 1)
        ]),
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('运单号')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(isD2C)() ? __props.rowItemDetail.settlementDeliveryRespDTO?.logisticsCode :
          __props.rowItemDetail.settlementDeliveryRespDTOList?.map((i) => i.logisticsCode).join(',')), 1)
        ]),
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('计费重量')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(isD2C)() ? __props.rowItemDetail.settlementDeliveryRespDTO?.weight :
          __props.rowItemDetail.settlementDeliveryRespDTOList?.reduce((total, v): number => {
            return total + v.weight
          }, 0)) + "KG", 1)
        ]),
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('国际送料（含远方送料手续费）')) + "：", 1),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_unref(reducePrice)(__props.rowItemDetail.settlementDeliveryRespDTOList?.reduce((total, v): number => {
            return total + v.freightFee + v.remoteAreaFee - v.discountFee
          }, 0))) + " " + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW')) + " ", 1),
            (_unref(isD2C)() ? __props.rowItemDetail.settlementDeliveryRespDTO.discountFee : __props.rowItemDetail.settlementDeliveryRespDTOList?.some(i => i.discountFee))
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('已优惠{x}元', {
              x:
                _unref(isD2C)() ? __props.rowItemDetail.settlementDeliveryRespDTO.discountFee :
                  __props.rowItemDetail.settlementDeliveryRespDTOList?.reduce((total, v): number => {
                    return total + (v?.discountFee ?? 0)
                  }, 0)
            })), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW')), 1)
        ]),
        (__props.rowItemDetail.fundFlowNo)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('流水号')) + "：", 1),
              _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.fundFlowNo), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.rowItemDetail?.createTime)), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})